export const COMPARISON_VALUE_TYPES = {
  CHECK: "check",
  CROSS: "cross",
  TEXT: "text",
} as const;

export type ComparisonValueType =
  (typeof COMPARISON_VALUE_TYPES)[keyof typeof COMPARISON_VALUE_TYPES];

export type ComparisonValue = {
  text?: string;
  type: ComparisonValueType;
};

export type BuyerLandingWhyChooseAutotraderProps = {
  eligibility?: boolean;
  onZipChange?: (zip: string) => Promise<void>;
  locationData?: {
    zip?: string;
    stateName?: string;
    city?: string;
    county?: string;
  } | null;
};

export const comparisonColumns = [
  { title: "Autotrader", subtitle: "Private Seller Exchange" },
  { title: "Craigslist", subtitle: "Cars + Trucks" },
  { title: "Facebook", subtitle: "Marketplace" },
];

export const comparisonRows: { feature: string; values: ComparisonValue[] }[] =
  [
    {
      feature: "Registration & Title Fees, Taxes",
      values: [
        { type: COMPARISON_VALUE_TYPES.CHECK, text: "Pay online option*" },
        { type: COMPARISON_VALUE_TYPES.TEXT, text: "Pay at DMV" },
        { type: COMPARISON_VALUE_TYPES.TEXT, text: "Pay at DMV" },
      ],
    },
    {
      feature: "Purchase Process",
      values: [
        { type: COMPARISON_VALUE_TYPES.CHECK, text: "Secure online checkout" },
        { type: COMPARISON_VALUE_TYPES.TEXT, text: "Pay seller directly" },
        { type: COMPARISON_VALUE_TYPES.TEXT, text: "Pay seller directly" },
      ],
    },
    {
      feature: "Clean Title Guarantee",
      values: [
        { type: COMPARISON_VALUE_TYPES.CHECK, text: "Available on all vehicles" },
        { type: COMPARISON_VALUE_TYPES.CROSS },
        { type: COMPARISON_VALUE_TYPES.CROSS },
      ],
    },
    {
      feature: "Seller Identity Verification",
      values: [
        {
          type: COMPARISON_VALUE_TYPES.CHECK,
          text: "Government ID & verification",
        },
        { type: COMPARISON_VALUE_TYPES.CROSS },
        { type: COMPARISON_VALUE_TYPES.TEXT, text: "Basic profile" },
      ],
    },
    {
      feature: "Financing Options",
      values: [
        {
          type: COMPARISON_VALUE_TYPES.CHECK,
          text: "Multiple lenders available",
        },
        { type: COMPARISON_VALUE_TYPES.CROSS },
        { type: COMPARISON_VALUE_TYPES.CROSS },
      ],
    },
    {
      feature: "Fraud Protection",
      values: [
        { type: COMPARISON_VALUE_TYPES.CHECK, text: "Professional monitoring" },
        { type: COMPARISON_VALUE_TYPES.TEXT, text: "Buyer beware" },
        { type: COMPARISON_VALUE_TYPES.TEXT, text: "Basic reporting" },
      ],
    },
    {
      feature: "Price Analysis Tool",
      values: [
        { type: COMPARISON_VALUE_TYPES.CHECK, text: "Real-time market data" },
        { type: COMPARISON_VALUE_TYPES.CROSS },
        { type: COMPARISON_VALUE_TYPES.CROSS },
      ],
    },
    {
      feature: "Customer Support",
      values: [
        {
          type: COMPARISON_VALUE_TYPES.CHECK,
          text: "Phone, email, or live chat with humans",
        },
        { type: COMPARISON_VALUE_TYPES.CROSS },
        { type: COMPARISON_VALUE_TYPES.CROSS },
      ],
    },
    {
      feature: "Selection of Vehicles",
      values: [
        { type: COMPARISON_VALUE_TYPES.CHECK, text: "Nationwide inventory" },
        { type: COMPARISON_VALUE_TYPES.TEXT, text: "Local vehicles only" },
        { type: COMPARISON_VALUE_TYPES.TEXT, text: "Local vehicles only" },
      ],
    },
  ];
